import { createEvent, sample } from 'effector'
import { fx } from '../../../libs'
import type { RecalcSummaryForm } from './types'

export const recalcActiveEvent = createEvent<RecalcSummaryForm>()
export const recalcPassiveEvent = createEvent<RecalcSummaryForm>()

export const recalcActive = fx<RecalcSummaryForm, void>({
  method: 'POST',
  url: '/finance/balance-summary-active/recalculate',
})

export const recalcPassive = fx<RecalcSummaryForm, void>({
  method: 'POST',
  url: '/finance/balance-summary-passive/recalculate',
})

sample({
  clock: recalcActiveEvent,
  fn: (form) => ({ body: form }),
  target: recalcActive,
})

sample({
  clock: recalcPassiveEvent,
  fn: (form) => ({ body: form }),
  target: recalcPassive,
})
